module.exports = __webpack_public_path__ + "img/no-image.1aa81263.png";